itsoftApp.createModule("sliderRange", ["filters"], function() {
    var module = this;
    var moduleInitialized = false;

    var initSliderRange = function (wrapper, filterElement) {
        var element = wrapper.querySelector(".js-range-element");
        var form = element.closest("form");
        var rangeMinElement = wrapper.querySelector(".form__range-min");
        var rangeMaxElement = wrapper.querySelector(".form__range-max");
        var rangeMinInput = wrapper.querySelector(".filters__input-min");
        var rangeMaxInput = wrapper.querySelector(".filters__input-max");

        var createSlider = function () {
            var settings = {
                connect: true
            };

            if (element.hasAttribute("data-range-min")) {
                if (rangeMinInput.value) {
                    settings.start = [+(rangeMinInput.value)];
                } else {
                    settings.start = [+(element.getAttribute("data-range-min"))];
                }
                settings.range = {
                    "min": +(element.getAttribute("data-range-min"))
                };
            }

            if (element.hasAttribute("data-range-max")) {
                if (rangeMaxInput.value) {
                    settings.start.push(+(rangeMaxInput.value));
                } else {
                    settings.start.push(+(element.getAttribute("data-range-max")));
                }
                settings.range.max = +(element.getAttribute("data-range-max"));
            }

            var formatting = wNumb({
                decimals: 0,
                suffix: unit
            });

            if (element.hasAttribute("data-range-unit")) {
                settings.format = formatting;
            }

            if (element.hasAttribute("data-range-tooltip")) {
                if (element.hasAttribute("data-range-unit")) {
                    var unit = element.getAttribute("data-range-unit");
                    settings.tooltips = [formatting, formatting]
                } else {
                    settings.tooltips = true;
                }
            }

            noUiSlider.create(element, settings);

            if (element.hasAttribute("data-update-value")) {
                var valuesElements = [
                    rangeMinElement,
                    rangeMaxElement
                ];

                element.noUiSlider.on("update", function (values, handle) {
                    var value = values[handle];
                    if (element.hasAttribute("data-range-unit")) {
                        value += " " + element.getAttribute("data-range-unit");
                    }
                    valuesElements[handle].innerHTML = value;
                });
            }

            if (filterElement) {
                itsoftApp.modules.filters.callback(filterElement);
            }
        }

        if (!moduleInitialized) {
            itsoftApp.loadScript("/assets/scripts/noUiSlider/nouislider.min.js", function (){
                itsoftApp.loadStyle("/assets/scripts/noUiSlider/nouislider.min.css");
                itsoftApp.loadScript("/assets/scripts/wNumb/wNumb.min.js", function () {
                    var moduleInitialized = true;
                    createSlider();
                });
            });
        } else {
            createSlider();
        }
    }

    module.callback = initSliderRange;
});